var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.logo,{key:_vm.name,tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"alt":"logo descomplica","title":"logo descomplica"}})}
var staticRenderFns = []

export { render, staticRenderFns }